import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './service-order.reducer';

export const ServiceOrderDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const serviceOrderEntity = useAppSelector(state => state.serviceOrder.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="serviceOrderDetailsHeading">
          <Translate contentKey="crawlerBackendApp.serviceOrder.detail.title">ServiceOrder</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{serviceOrderEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="crawlerBackendApp.serviceOrder.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            {serviceOrderEntity.startDate ? (
              <TextFormat value={serviceOrderEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="crawlerBackendApp.serviceOrder.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            {serviceOrderEntity.endDate ? (
              <TextFormat value={serviceOrderEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="serviceStatus">
              <Translate contentKey="crawlerBackendApp.serviceOrder.serviceStatus">Service Status</Translate>
            </span>
          </dt>
          <dd>{serviceOrderEntity.serviceStatus}</dd>
          <dt>
            <span id="createdTimestamp">
              <Translate contentKey="crawlerBackendApp.serviceOrder.createdTimestamp">Created Timestamp</Translate>
            </span>
          </dt>
          <dd>
            {serviceOrderEntity.createdTimestamp ? (
              <TextFormat value={serviceOrderEntity.createdTimestamp} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.serviceOrder.productOrder">Product Order</Translate>
          </dt>
          <dd>{serviceOrderEntity.productOrder ? serviceOrderEntity.productOrder.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/service-order" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/service-order/${serviceOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ServiceOrderDetail;
